import { Modal, Radio, Form,Row ,Col, Button } from 'antd'
import React, { useState } from 'react'
import { ButtonEx } from '../../../../styles/button.style'
import _, { isNull } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'

const UpdateAdvance = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        advance: formData.advance,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          advance: values.advance
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title="Update Advance"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item>
          {getFieldDecorator(`advance`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group
              name="advance"
            >
              <Radio value={true}>ใช่</Radio>
              <Radio value={false}>ไม่</Radio>
            </Radio.Group>)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>Cancel</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              OK
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUpdateAdvance = Form.create({
  name: 'UpdateAdvance'
})(UpdateAdvance)
export default (WrappedUpdateAdvance)
